import _ from 'lodash';
import { buildValidationParameters, buildGlobalValidationParameters } from 'shared/product_tabs/tab_stencils/slice/utils/validatorRules';
import { validator } from 'shared/product_tabs/tab_stencils/slice/validator';

const areGlobalStencilParametersValid = (stencilsParameters) => {
  const parameters = stencilsParameters || {};
  const validationParameters = buildGlobalValidationParameters(parameters);

  return Object.keys(validationParameters)
    .map((key) => validator.check(validationParameters[key].value, validationParameters[key].rule))
    .reduce((acc, curr) => acc && curr, true);
};

const isStencilAvailableForCart = (stencil, stencilsType) => {
  const parameters = stencil.parameters || {};
  const validationParameters = buildValidationParameters(stencilsType, parameters);
  return Object.keys(validationParameters)
    .map((key) => validator.check(validationParameters[key].value, validationParameters[key].rule))
    .reduce((acc, curr) => acc && curr, true);
};

export const updateStencilsForOrder = (state) => {
  const invalidStencilsForCart = state.stencils.filter((s) => !isStencilAvailableForCart(s, state.stencilsType));

  if (areGlobalStencilParametersValid(state.stencilsParameters) && !invalidStencilsForCart.length) {
    state.stencilsToBuy = _.cloneDeep(state.stencils);
  }
};
